export default {
  namespaced: true,
  state: {
    alertMessage: '',
    isProcessing: false,
  },
  mutations: {
    SET_MESSAGE(state, payload) {
      state.alertMessage = payload;
    },
    SET_IS_PROCESSING(state, payload) {
      state.isProcessing = payload;
    }
  },
  getters: {
    getMessage(state) {
      return state.alertMessage;
    },
    getIsProcessing(state) {
      return state.isProcessing;
    }
  },
  actions: {
    setMessage({commit}, payload) {
      commit('SET_MESSAGE', payload);
    },
    setIsProcessing({commit}, payload) {
      commit('SET_IS_PROCESSING', payload);
    }
  }
}